// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jCFw","index":"styles_index__3M_cG"};